module.exports = __webpack_public_path__ + "media/common/icon_search-c7b95cb0.svg";